import { Typography } from "@hellocarbo/lasagne";
import { Trans, useTranslation } from "react-i18next";

import Analysis from "@/assets/common/other_icons/analysis.svg?react";
import Collect from "@/assets/common/other_icons/collect.svg?react";
import Reduction from "@/assets/common/other_icons/reduction.svg?react";
import Scoping from "@/assets/common/other_icons/scoping.svg?react";
import { CoachingItem } from "@/components/Coaching";
import PageWrapper from "@/components/ui/PageWrapper";

function Coaching() {
  const { t } = useTranslation("coaching");

  return (
    <PageWrapper>
      <div className="mx-xl my-lg">
        <Typography as="h1" step="3" weight="bold" className="mb-xs">
          {t("coaching:title")}
        </Typography>
        <Typography className="mb-md">
          <Trans
            t={t}
            i18nKey="coaching:description"
            components={{ 1: <br /> }}
          />
        </Typography>
        <ul className="gap-y-sm flex flex-col">
          <CoachingItem
            title={t("coaching:additionalScoping.title")}
            description={t("coaching:additionalScoping.description")}
            Icon={Scoping}
          />
          <CoachingItem
            title={t("coaching:dataCollectionSupport.title")}
            description={t("coaching:dataCollectionSupport.description")}
            Icon={Collect}
          />
          <CoachingItem
            title={t("coaching:analysisSupport.title")}
            description={t("coaching:analysisSupport.description")}
            Icon={Analysis}
          />
          <CoachingItem
            title={t("coaching:reductionPlanSupport.title")}
            description={t("coaching:reductionPlanSupport.description")}
            Icon={Reduction}
          />
        </ul>
      </div>
    </PageWrapper>
  );
}

export default Coaching;
